<template>
    <div class="page page-center">
        <div class="container-tight py-4">
            <div class="empty">
                <div class="empty-img">
                    <icon icon="logout" height="128" />
                </div>
                <p class="empty-title">Logout</p>
                <p class="empty-subtitle text-muted">
                    Do you want to logout?
                </p>
                <div class="empty-action">
                    <a @click="logout" class="btn btn-primary">
                        Logout
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        logout() {
            this.$store.dispatch("auth/logout").then(() => {
                this.$router.push({ name: "login" });
            });
        }
    },
    created() {
    }
};
</script>
